import { c as _c } from "react/compiler-runtime";
import { type ComponentType } from "react";
import { type ShelfFilterField } from "@/shelves";
import * as icon from "./source";
import { type StyledIconProps } from "./styled";
type FieldIconKey = ShelfFilterField | "authors" | "seriesPosition";
type FieldIconDef = {
  base: ComponentType<StyledIconProps>;
  add?: ComponentType<StyledIconProps>;
  remove?: ComponentType<StyledIconProps>;
  filled?: ComponentType<StyledIconProps>;
};
const FIELD_ICONS: Record<FieldIconKey, FieldIconDef> = {
  title: {
    base: icon.Heading
  },
  subtitle: {
    base: icon.TextCaption
  },
  description: {
    base: icon.AlignLeft
  },
  language: {
    base: icon.Language
  },
  review: {
    base: icon.Pencil
  },
  search: {
    base: icon.Search
  },
  alignmentGrade: {
    base: icon.Certificate
  },
  status: {
    base: icon.Progress
  },
  tags: {
    base: icon.Tag,
    add: icon.TagAdd,
    remove: icon.TagRemove,
    filled: icon.TagFilled
  },
  collections: {
    base: icon.Folders
  },
  series: {
    base: icon.Books
  },
  creators: {
    base: icon.Users
  },
  narrators: {
    base: icon.Microphone
  },
  translators: {
    base: icon.Language
  },
  authors: {
    base: icon.User
  },
  format: {
    base: icon.BookAlt
  },
  userRating: {
    base: icon.Star
  },
  pageCount: {
    base: icon.FileText
  },
  duration: {
    base: icon.Clock
  },
  fileSize: {
    base: icon.Database
  },
  readingPosition: {
    base: icon.Bookmark
  },
  alignmentScore: {
    base: icon.ChartBar
  },
  alignmentMissingSentences: {
    base: icon.AlertTriangle
  },
  alignmentMutedChapters: {
    base: icon.Volume3
  },
  // alignmentMissingChapters: { base: icon.VolumeOff },
  publicationDate: {
    base: icon.Calendar
  },
  createdAt: {
    base: icon.CalendarPlus
  },
  updatedAt: {
    base: icon.History
  },
  alignedAt: {
    base: icon.CalendarCheck
  },
  alignedWith: {
    base: icon.Microphone2
  },
  alignedByStorytellerVersion: {
    base: icon.Stack
  },
  lastRead: {
    base: icon.Eye
  },
  seriesPosition: {
    base: icon.ListNumbers
  },
  identifiers: {
    base: icon.Link
  }
};
export type { FieldIconKey };
export function fieldIcon(field: FieldIconKey, variant: "base" | "add" | "remove" | "filled" = "base"): ComponentType<StyledIconProps> {
  const def = FIELD_ICONS[field];
  const resolved = def[variant];
  if (resolved) return resolved;
  return def.base;
}
export function FieldIcon(t0) {
  const $ = _c(10);
  let field;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      field,
      variant: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = field;
    $[2] = props;
    $[3] = t1;
  } else {
    field = $[1];
    props = $[2];
    t1 = $[3];
  }
  const variant = t1 === undefined ? "base" : t1;
  let t2;
  if ($[4] !== field || $[5] !== variant) {
    t2 = fieldIcon(field, variant);
    $[4] = field;
    $[5] = variant;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const Icon = t2;
  let t3;
  if ($[7] !== Icon || $[8] !== props) {
    t3 = <Icon {...props} />;
    $[7] = Icon;
    $[8] = props;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}